import { useIsEInvoicingOnly } from '@features/bills/hooks/useIsEInvoicingOnly'

export const useCanUseHelpCenter = () => {
  const isEInvoicingOnly = useIsEInvoicingOnly()

  return !isEInvoicingOnly
}
